/**
 * Identité provisoire. Seul endroit à modifier pour renommer le produit
 * (le frontend, les e-mails et la documentation OpenAPI lisent ces valeurs).
 */
export const BRAND = {
  name: 'Kadr',
  tagline: 'Des vidéos courtes prêtes à publier, dans toutes les langues.',
  supportEmail: 'support@kadr.local',
} as const;
